import data from "./publicRoutes.json";

export const SITE_URL = data.siteUrl;
export const PUBLIC_ROUTES = data.routes;
export const OG_IMAGE = `${SITE_URL}/iphix-logo.png`;

export const getRouteMeta = (path) => PUBLIC_ROUTES.find((r) => r.path === path) || null;
